<template lang="html">
<div :class="[customClass, 'input-group']">
  <div class="input-group-prepend">
    <span class="input-group-text"><i :class="icon.css"></i></span>
  </div>
  <select class="custom-select"
      v-model="newValue">
   <option disabled value="">Please select one</option>
     <option v-for="(item, key) in items"
        :key="key"
        :value="item">{{ item[itemKeys.display]}}</option>
  </select>
      <div v-if="errorMessage" class="invalid-feedback">{{ errorMessage[0] }}</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      newValue: null
    }
  },
  props: {
    value: {},
    items: {},
    errorMessage: {},
    fullItem: false,
    icon: { css: null },
    itemKeys: {
      default () {
        return { display: 'name' }
      }
    },
    customClass: {
      type: String,
      required: false
    }
  },
  mounted () {
    this.newValue = this.value
    if (!this.value) this.newValue = ''
  },
  watch: {
    newValue (value) {
      this.$emit('input', value)
      this.$emit('select', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.small-margin {
  margin: 5px;
}
</style>
